<template>
  <div class="xiangmu">
      <!--        <div class="h-crumbOut">-->
      <!--            <div class="h-crumbs">-->
      <!--                <el-breadcrumb separator="|">-->
      <!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
      <!--                    <el-breadcrumb-item>价格管理</el-breadcrumb-item>-->
      <!--                </el-breadcrumb>-->
      <!--            </div>-->
      <!--        </div>-->
      <Breadtabsheader/>
      <div class="h-piece h-mrt30">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="产品编码/名称">
                <el-input v-model="q.materialLike" placeholder="输入产品编码或名称"></el-input>
              </el-form-item>
              <el-form-item label="经销商代码/名称">
                <el-input v-model="q.agentLike" placeholder="输入经销商代码或名称"></el-input>
              </el-form-item>
              <el-form-item label="销售区域">
                <brselect category="YlSalesArea_chanpin" :v="q.salesregion"  v-model="q.salesregion" ></brselect>
              </el-form-item>

              <el-form-item label="产品大类">
                <brselectlazy style="width: 100%;" category="product_level" :v="q.oneLid" v-model="q.oneLid" :clearable="true"/>
              </el-form-item>
              <el-form-item class="right-btn">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhi">重置</el-button>
                <el-button
                    class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                    @click="createDingjia"
                >新增定价
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30 Ju">
        <el-table
            ref="multipleTable"
            :span-method="objectSpanMethod"
            @selection-change="handleSelectionChange"
            :data="tableData2"
            style="width: 100%"
            :border="true"
            max-height="440"
        >
          <el-table-column
              type="selection"
              width="40"
              :label="all"
          >
          </el-table-column>
          <el-table-column
              fixed
              type="index"
              label="#"
              width="40">
          </el-table-column>
          <el-table-column
              prop="prodseries"
              label="产品大类"
              min-width="80"
              :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
              prop="materialCode"
              label="产品编号"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="materialDescrition"
              label="产品型号"
              min-width="150"
              :show-overflow-tooltip="true"
          >

          </el-table-column>
          <el-table-column
              prop="isuse"
              label="是否可用"
              width="50">
            <template slot-scope="scope">
              {{scope.row.isuse|dictname('shifou_keyong')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="ispass"
              label="状态"
              width="100">
            <template slot-scope="scope">
              {{scope.row.ispass|dictname('DINGJIA_ZHUANGTAI')}}
            </template>
          </el-table-column>

          <el-table-column
              prop="agentName"
              label="经销商名称"
              min-width="150"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="agentCode"
              label="经销商编码"
              min-width="100"
              :show-overflow-tooltip="true"
          >
          </el-table-column>


          <el-table-column
              prop="leltypecode"
              label="定价类型"
              min-width="80"
              :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.leltypecode=='1'">内销</div>
              <div v-if="scope.row.leltypecode=='2'">外销</div>
              <div v-if="scope.row.leltypecode=='3'">外贸</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="protype"
              label="型号属性"
              min-width="80"
              :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
              prop="value"
              label="价格"
              min-width="80"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="currency"
              label="币种"
              min-width="150"
              :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.currency | dictname('YLCurrency') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="salesregionName"
              label="销售区域"
              min-width="80"
              :show-overflow-tooltip="true"
          >
          </el-table-column>



          <el-table-column
              prop="cuname"
              label="创建人"
              min-width="80"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="cdate"
              label="创建时间"
              min-width="150"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              label="操作"
              width="210"
              fixed="right"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                <el-button
                    v-if="scope.row.ispass==2 || scope.row.ispass==4"
                    type="text"
                    size="small"
                    class="h-tableLink h-btn" @click="dingjiaxiugai(scope.row)">
                  修改
                </el-button>
                <el-button
                    v-if="scope.row.ispass==1 || scope.row.ispass==3"
                    type="text"
                    size="small"
                    class="h-tableLink h-btn" @click="dingjiaSee(scope.row)">
                  查看
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    class="h-tableLink h-btn" @click="toDelete(scope.row)">
                  删除
                </el-button>

                <el-button v-if="scope.row.instid" type="text" size="small" class="h-tableLink h-btn" @click="chakanjindu(scope.row.instid)">跟踪</el-button>

              </div>

            </template>
          </el-table-column>
        </el-table>


        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       v-if="adminFlag || this.priceAdmin"
                       style="margin-left:-20px;" @click="exportExcel">批量导出
            </el-button>

            <el-button
                class="h-btn h-formBtn h-bgblueQ"
                icon="h-el-icon h-el-icon-export"
                @click="uploaddownexcelflagbtn">
              批量导入
            </el-button>
            <uploaddownexcel
                :visible.sync="uploaddownexcelflag"
                v-if="uploaddownexcelflag"
                clsname="companyPriceImportExcel"
                :startrow="2"
                @callback="uploadExcelFilecallback"/>
          </div>
          <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showinstid"/>

          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import ss from '../../api/SystemService'
import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
import companyPrice from "@/api/price/companyPrice";
import updownfile from "@/utils/updownfile";

export default {
  components: {
    uploaddownexcel,
  },
  data() {
    return {

      dialogVisible: false,
      dialog2Visible: false,
      dialog: {
        marketTypeLog: '',
        materialCodeLog: '',
      },

      showinstid: null,
      showhistory: false,
      //批量导入
      uploaddownexcelflag: false,
      showOrhide: false,
      status: 1,
      checked: true,
      toshow: "priceManage",

      dingjiazhuangtai: [
        {
          value: 1,
          label: '已定价'
        }, {
          value: 0,
          label: '未定价'
        }, {
          value: 2,
          label: '暂存'
        }, {
          value: 3,
          label: '提交审核中'
        }],

      wuliaozu: [],

      chanpindalei: [],

      suoyoudingjia: {},

      dingjiashijian: {},

      q: {

        oneLid: null,
        materialLike:null,
        agentLike:null,
        salesregion:null,
        pageSize: 10,
        pageNo: 1,
        total: 0,

      },

      //表单
      all: '全部',
      formInline: {
        dalei: '',
        status: '',
        group: '',
        type: '',
      },
      //表格
      multipleSelection: [],
      tableData2: [],
      adminFlag: false,
      priceAdmin: false,

      spanArr: [],
    }
  },

  //加载页面默认执行
  created() {
    //是否有财务权限
    this.caiwuFlag = this.$store.getters.hasRole('swyl_caiwujl');
    //是否管理员权限
    this.adminFlag = this.$store.getters.hasRole('swyl_admin');
    //是否价格管理员
    this.priceAdmin = this.$store.getters.hasRole('swyl_pricegly');

    this.query();
  },


  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },


  //监听
  watch: {},


  methods: {
//导入Excel
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.query();
      this.$msg.msgs(rd.msg);
    },

    handleCurrentChange() {

    },
    handleSizeChange() {

    },


    //重置
    chongzhi() {

      this.q.oneLid = '';

      this.q.materialLike = '';

      this.q.agentLike = '';

      this.q.salesregion = '';

    },


    //查询翻页
    query() {

      ss.companyPrice.selectPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData2= rd.records;
        this.getSpanArr();
      });

    },

  //查看进度
    chakanjindu(q){
      this.showinstid = q;
      this.showhistory = true;
    },
    handleFilter() {
      this.q.pageNo = 1;
      this.query();
    },


    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },

    //明细导出
    exportExcel() {
      var idlist = [];
      this.multipleSelection.forEach(element => {
        idlist.push(element.id);
      });
      updownfile.down("/api/swyl/v1/price/companyMaterialInfoPrice/downloadExcel", idlist, "post", 'data');
    },



    //新增定价
    createDingjia() {
      this.$router.push({path: "/chanp/createCompanyPrice"});
    },

    //删除定价
    toDelete(q) {
      console.log("qqqqq",q)
      this.$msg.confirm("确认删除?", () => {
        ss.companyPrice.toDelete(q.shenpibanben).then(rd => {
          this.$msg.msgs(rd.msg);
          this.query();
        });
      });
    },
    //修改定价
    dingjiaxiugai(q) {
       if (q.materialCode) {
        this.$router.push({path: '/chanp/createCompanyPrice', query: q});
      } else {
        this.$msg.msge('数据错误，缺少必要的物料号')
      }
    },
    //查看定价
    dingjiaSee(q) {
      if (q.materialCode) {
        this.$router.push({path: '/chanp/companyPriceOnlyRead', query: q});
      } else {
        this.$msg.msge('数据错误，缺少必要的物料号')
      }
    },

    getSpanArr() {
      this.spanArr = [];
      this.tableData2.forEach((item, index) => {
          if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (this.tableData2[index].shenpibanben === this.tableData2[index - 1].shenpibanben) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      })
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
       if (
           (column.label == '经销商名称')
               ||
          (column.label == '经销商编码')
          ||
          (column.label == '定价类型')
           ||
          (column.label == '销售区域')
           ||
           (column.label == '币种')
          ||
          (column.label == '操作')
      ) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },

  },

  mounted() {
    // this.status = sessionStorage.priceManage?sessionStorage.priceManage:1;
    // if(sessionStorage.priceManage != 2){
    // 	this.showOrhide = true;
    // }
  },
}
</script>
<style scoped>
.xiangmu > .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 3rem !important;
}
</style>
<style>
.Ju .h-btn.el-button.h-tableLink {
  padding: 0 0.05rem;
}

</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
  z-index: 999999;
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785E7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .steps {
    position: absolute;
    z-index: 1;
  }

  .step1 {
    top: 0;
    left: 0;
  }

  .step2 {
    top: 0;
    left: 0;
  }

  .step3 {
    top: 0;
    left: 0;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
    z-index: 2;
  }
}
</style>


